import {Button, Layout, Menu, Modal} from "antd";
import React, {useEffect} from "react";
import Sider from "antd/es/layout/Sider";
import {Content} from "antd/es/layout/layout";
import {AISettings} from "./AISettings";
import {StorageSettings} from "./StorageSettings";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBolt, faCompactDisc, faUser} from "@fortawesome/free-solid-svg-icons";
import {ProfileSettings} from "./ProfileSettings";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {closeAccountSettings} from "../../feature/project/appSettingsSlice";

export const SettingsContent = (props: {
    saveFunction: (saveFunction: () => void) => void
}) => {
    const accountSettings = useAppSelector(state => state.appSettingsSlice.accountSettings)
    const [category, setCategory] = React.useState(accountSettings)

    useEffect(() => {
        setCategory(accountSettings)
    }, [accountSettings]);

    return (
        <Layout style={{maxHeight: 800, overflow: 'hidden'}}>
            <Sider width={200}>
                <Menu
                    defaultSelectedKeys={[category as string]}
                    selectedKeys={[category as string]}
                    mode="inline"
                    style={{height: '100%', borderInlineEnd: '0'}}
                    items={[
                        {
                            key: 'profile',
                            label: 'Profile Settings',
                            icon: <FontAwesomeIcon icon={faUser}/>
                        },
                        {
                            key: 'ai',
                            label: 'AI Settings',
                            icon: <FontAwesomeIcon icon={faBolt}/>
                        },
                        {
                            key: 'storage',
                            label: 'Storage Settings',
                            icon: <FontAwesomeIcon icon={faCompactDisc}/>
                        }
                    ]}
                    onClick={(item) => {
                        // @ts-ignore
                        setCategory(item.key)
                    }}
                />
            </Sider>
            <Content style={{padding: '0 0 0 20px ', overflowY: 'auto', minWidth: 600, background: "#fff"}}>
                {category === 'profile' ?
                    <ProfileSettings saveFunction={(saveFunction) => props.saveFunction(saveFunction)}/> : ''}
                {category === 'ai' ?
                    <AISettings saveFunction={(saveFunction) => props.saveFunction(saveFunction)}/> : ''}
                {category === 'storage' ?
                    <StorageSettings saveFunction={(saveFunction) => props.saveFunction(saveFunction)}/> : ''}
            </Content>
        </Layout>

    )
}

export const AccountSettingsModal = (props: {}) => {
    const accountSettings = useAppSelector(state => state.appSettingsSlice.accountSettings)
    const dispatch = useAppDispatch()
    const [saveFunction, setSaveFunction] = React.useState<{ fn: () => void } | undefined>(undefined)

    return (
        <Modal
            zIndex={accountSettings == 'ai' || accountSettings == 'storage' ? 10000 : 0}
            open={accountSettings != undefined}
            onCancel={() => dispatch(closeAccountSettings())}
            cancelText={'Close'}
            okText={'Save'}
            onOk={() => {
                if (saveFunction) {
                    saveFunction.fn()
                }
            }}
            title={'Settings'}
            width={1000}
            footer={[
                <Button key="back" onClick={() => dispatch(closeAccountSettings())}>
                    Close
                </Button>,
                <Button key="submit" type="primary" onClick={() => {
                    if (saveFunction) {
                        saveFunction.fn()
                    }
                }}>
                    Save
                </Button>,
                <Button
                    key="save_and_close"
                    type="primary"
                    onClick={() => {
                        if (saveFunction) {
                            saveFunction.fn()
                        }
                        dispatch(closeAccountSettings())
                    }}
                >
                    Save and Close
                </Button>,
            ]}
        >
            <SettingsContent saveFunction={(sFunction) => setSaveFunction({fn: sFunction})}/>
        </Modal>
    )
}